class ShopByCategory extends HTMLElement {
    constructor() {
        super();
        this.container = this.querySelector(".shop-by-category__content-container");
        this.scrollbar = this.querySelector(".shop-by-category__content-container__scrollbar");
        this.scrollbarLine = this.querySelector(".shop-by-category__content-container__scrollbar__line");
        this.scrollForMore = this.querySelector(".shop-by-category__content-header_scroll-for-more");

        if (!this.container || !this.scrollbar || !this.scrollbarLine || !this.scrollForMore) return;

        this.scrollAmount = 300; // Distância da rolagem ao clicar na seta
        this.isTouching = false;

        this.init();
    }

    init() {
        this.setScrollBarWidth();
        this.syncScrollBar();
        this.updateScrollButtons();

        this.scrollForMore.addEventListener("click", () => this.scrollRight());
        this.scrollbarLine.addEventListener("mousedown", (e) => this.startDrag(e));
        this.container.addEventListener("scroll", () => this.syncScrollBar());
        this.container.addEventListener("wheel", (e) => this.handleWheel(e), { passive: false });

        this.container.addEventListener("touchstart", (e) => this.startTouch(e));
        this.container.addEventListener("touchmove", (e) => this.moveTouch(e));
        this.container.addEventListener("touchend", () => this.endTouch());

        window.addEventListener("resize", () => {
            this.setScrollBarWidth();
            this.syncScrollBar();
        });
    }

    setScrollBarWidth() {
        const visibleWidth = this.container.clientWidth;
        const totalWidth = this.container.scrollWidth;
        const scrollBarWidth = (visibleWidth / totalWidth) * this.scrollbar.clientWidth;
        this.scrollbarLine.style.width = `${scrollBarWidth}px`;
    }

    syncScrollBar() {
        const scrollLeft = this.container.scrollLeft;
        const maxScrollLeft = this.container.scrollWidth - this.container.clientWidth;
        const maxScrollBarLeft = this.scrollbar.clientWidth - this.scrollbarLine.clientWidth;
        this.scrollbarLine.style.left = `${(scrollLeft / maxScrollLeft) * maxScrollBarLeft}px`;
        this.updateScrollButtons();
    }

    scrollRight() {
        this.container.scrollBy({ left: this.scrollAmount, behavior: "smooth" });
    }

    updateScrollButtons() {
        this.scrollForMore.style.opacity =
            this.container.scrollLeft + this.container.clientWidth < this.container.scrollWidth ? "1" : "0.5";
    }

    startDrag(e) {
        e.preventDefault();
        
        this.mouseMoveHandler = this.syncContainerScroll.bind(this);
        this.mouseUpHandler = () => {
            document.removeEventListener("mousemove", this.mouseMoveHandler);
            document.removeEventListener("mouseup", this.mouseUpHandler);
        };
    
        document.addEventListener("mousemove", this.mouseMoveHandler);
        document.addEventListener("mouseup", this.mouseUpHandler, { once: true });
    }

    syncContainerScroll(e) {
        const maxScrollLeft = this.container.scrollWidth - this.container.clientWidth;
        const maxScrollBarLeft = this.scrollbar.clientWidth - this.scrollbarLine.clientWidth;
        const newLeft = Math.min(Math.max(0, e.clientX - this.scrollbar.offsetLeft - this.scrollbarLine.clientWidth / 2), maxScrollBarLeft);
        this.scrollbarLine.style.left = `${newLeft}px`;
        this.container.scrollLeft = (newLeft / maxScrollBarLeft) * maxScrollLeft;
    }

    handleWheel(e) {
        e.preventDefault();
        const scrollDelta = e.deltaX !== 0 ? e.deltaX : e.deltaY;
        this.container.scrollLeft += scrollDelta;
        this.syncScrollBar();
    }

    startTouch(e) {
        this.isTouching = true;
        this.startX = e.touches[0].clientX; // Usa clientX para precisão
        this.startScrollLeft = this.container.scrollLeft; // Mantém a posição exata do scroll
    }
    
    moveTouch(e) {
        if (!this.isTouching) return;
        const x = e.touches[0].clientX;
        const walk = this.startX - x; // Mantém a direção correta do movimento
        this.container.scrollLeft = this.startScrollLeft + walk; // Move sem resetar o scrollLeft
        this.syncScrollBar();
    }
    

    endTouch() {
        this.isTouching = false;
    }
}

customElements.define("shop-by-category", ShopByCategory);